<template>
  <div class="notice notice-container">
    <SectionTriangle height="288px" data-aos="fade-in">
      <div class="txtcon">
        <div class="txt">
          <h2 class="planh1">
            {{ $t("news.t1") }}
          </h2>
          <p class="planp">
            {{ $t("news.t2") }}
          </p>
        </div>
      </div>
    </SectionTriangle>

    <!-- <section class="weekly" data-aos="fade-in">
      <div class="content-container">
        <h3>最新周报</h3>
        <a-card hoverable>
          <img alt="example" :src="weekly.imgSrc" slot="cover" />
          <a-card-meta :title="weekly.time">
            <template slot="description">
              <h5>{{ weekly.title }}</h5>
              <div class="desc">{{ weekly.content }}</div>
            </template>
          </a-card-meta>
        </a-card>
      </div>
    </section> -->

    <div class="weekly-container content-container">
      <h1>{{ $t("news.s1.h1") }}</h1>
      <div class="content-wrapper">
        <div class="img-item">
          <img :src="demoimg" alt="">
        </div>

        <div class="intro-item">
          <p class="time">
            March 4,2020
          </p>
          <p class="title">
            {{ $t("news.s1.t1") }}
          </p>
          <p class="content">
            {{ $t("news.s1.t2") }}
          </p>
          <myButton
            class="mt10"
            custom-type="link"
            href="https://lambdastorage.zendesk.com/hc/zh-cn/articles/360006405278-Lambda%E7%AC%AC%E4%B8%89%E6%9C%9F%E5%AD%98%E5%82%A8%E6%B5%8B%E8%AF%95%E9%A2%84%E5%91%8A"
          >
            {{ $t("news.s1.btn") }}
          </myButton>
        </div>
      </div>
    </div>

    <Mediacoverage data-aos="fade-in" />

    <div class="section7-container-part6" data-aos="fade-in" />
  </div>
</template>

<script>
import SectionTriangle from "@/components/SectionTriangle.vue";

import Mediacoverage from "@/components/Mediacoverage.vue";
import demoimg from "@/assets/04demo@2x.png";
export default {
  components: {
    SectionTriangle,
    Mediacoverage,
    myButton: () => import("@/components/MyButton.vue")
  },
  data() {
    return {
      demoimg
    };
  }
};
</script>

<style lang="less" scoped>
@media (max-width: 500px) {
  .notice-container {
    .planh1 {
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 45px;
    }
    .planp {
      text-align: center;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 20px;
    }
    .weekly-container {
      margin-top: 50px;
      h1 {
        text-align: center;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(38, 38, 38, 1);
        line-height: 40px;
      }
      .content-wrapper {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        .img-item {
          width: 100%;
          img {
            max-width: 100%;
          }
        }
        .intro-item {
          margin-top: 20px;
          width: 100%;
          .time {
            font-size: 13px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(86, 86, 86, 1);
            line-height: 18px;
          }
          .title {
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(38, 38, 38, 1);
            line-height: 25px;
          }
          .content {
            font-size: 15px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(38, 38, 38, 1);
            line-height: 24px;
          }
        }
      }
    }
  }
}

@media (min-width: 501px) {
  .notice-container {
    .planh1 {
      text-align: center;
      font-size: 44px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 62px;
    }
    .planp {
      text-align: center;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 37px;
    }
    .weekly-container {
      margin-top: 50px;
      h1 {
        font-size: 34px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(38, 38, 38, 1);
        line-height: 48px;
      }
      .content-wrapper {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;
        .img-item {
          width: 40%;
          img {
            max-width: 100%;
          }
        }
        .intro-item {
          width: 52%;
          .time {
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(86, 86, 86, 1);
            line-height: 25px;
          }
          .title {
            font-size: 24px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(38, 38, 38, 1);
            line-height: 33px;
          }
          .content {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(38, 38, 38, 1);
            line-height: 24px;
          }
        }
      }
    }
  }
}
</style>
